import { DoNotDisturbAltOutlined as DoNotDisturbAltOutlinedIcon, CheckCircleOutline as CheckCircleOutlineIcon } from "@mui/icons-material";

export const ExistMenuName = ({ exist, messageExist, messageNoExist }) => {
    return <div>
        {exist ? <div style={{ display: "flex" }}>
            <DoNotDisturbAltOutlinedIcon style={{ color: "red", marginRight: 4 }} />
            <span>{messageExist}</span>
        </div> : <div style={{ display: "flex" }}>
            <CheckCircleOutlineIcon style={{ color: "green", marginRight: 4 }} />
            <span>{messageNoExist}</span>
        </div>}
    </div>
}